<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<mat-toolbar *ngIf="messageVisible" class="nav-bar" color="{{messageColor}}">
  <div class="header"  fxLayout="row" fxLayoutAlign="space-between center">
    <span>{{message}}</span>
    <button mat-icon-button (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</mat-toolbar>
